let pendingGtagEvents = []
let gtagWatcher = null

const watchForGtag = () => {
  if (gtagWatcher) return

  let attempts = 0

  gtagWatcher = setInterval(() => {
    attempts++

    if (window.gtag) {
      pendingGtagEvents.forEach(({ eventName, eventDetails }) => {
        window.gtag("event", eventName, { ...eventDetails })
      })
    } else if (attempts < 10) {
      return
    }

    clearInterval(gtagWatcher)
    gtagWatcher = null
    pendingGtagEvents = []
  }, 1000)
}

export const sendEvent = (eventName, eventDetails) => {
  window.igEvents = window.igEvents || []
  window.igEvents.push({
    event: eventName,
    properties: {
      ...eventDetails,
    },
  })

  if (window.gtag) {
    window.gtag("event", eventName, {
      ...eventDetails,
    })
  } else {
    pendingGtagEvents.push({ eventName, eventDetails })
    watchForGtag()
  }
}
